import { getUserId } from "@/services/supabase/auth/actions/getUserId";
import { supabase } from "@/services/supabase/createClient";
import type { PSResourceType } from "@pufflig/prompt-studio-types";

export const createResource = async (
  name: string,
  workspaceId: string,
  resourceType: PSResourceType,
  teamId?: string,
) => {
  const ownerId = teamId || (await getUserId());

  const { data: resourceId, error } = await supabase.rpc("create_resource", {
    owner_uuid: ownerId,
    workspace_uuid: workspaceId,
    resource_type: resourceType,
    resource_name: name,
  });

  return { resourceId, error };
};
